import { Route, Routes } from 'react-router-dom'

import { RoutesEnabled } from 'app/routes/model.ts'
import { RouteAccess } from 'app/routes/route-access.tsx'
import { RoutingPaths } from 'app/routes/routes'

import {
  UmrahDetailPage,
  UmrahGalleryPage,
  UmrahMainPage,
  UmrahMyOrderDetailPage,
  UmrahPrepaymentPage,
  UmrahPreviewPage,
} from '../'

export const UmrahPages = () => {
  return (
    <RouteAccess enabled={RoutesEnabled.umrah}>
      <Routes>
        <Route
          path={RoutingPaths.umrah.start()}
          element={<UmrahMainPage />}
        />

        <Route
          path={RoutingPaths.umrah.prepayment.base()}
          element={<UmrahPrepaymentPage />}
        />

        <Route
          path={RoutingPaths.umrah.tourDetail.base()}
          element={<UmrahDetailPage />}
        />

        <Route
          path={RoutingPaths.umrah.gallery.base()}
          element={<UmrahGalleryPage />}
        />

        <Route
          path={RoutingPaths.umrah.preview.base()}
          element={<UmrahPreviewPage />}
        />

        <Route
          path={RoutingPaths.umrah.myOrderDetails.base()}
          element={<UmrahMyOrderDetailPage />}
        />
      </Routes>
    </RouteAccess>
  )
}
